"use strict";

Shopify.theme.jsSearch = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsSearch = $.extend(this, Shopify.theme.getSectionData($section)); // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object

    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }
    var noSearchResult = setInterval(function(){
      if(document.querySelector('.boost-pfs-filter-message') != null){
        console.log('gello');
        document.querySelector('[data-search-results]').classList.add('d-none');
        document.querySelector('[data-no-search-results]').classList.remove('d-none');
        var searchMsg = document.querySelector('.boost-pfs-filter-message p').innerHTML;
        searchMsg += '. These popular categories might interest you.';
        document.querySelector('.boost-pfs-filter-message').innerHTML = searchMsg;
        clearInterval(noSearchResult);
      }
    },100)

    setTimeout(function(){
      clearInterval(noSearchResult);
    },5000)
//     console.log('search-box',$('#boost-pfs-search-box-2'))
    
    $(document).on('keydown','#boost-pfs-search-box-2',function(){
    $('body.search .boost-pfs-search-suggestion-mobile-top-panel form input').val($(this).val())
        $('body.search .boost-pfs-search-suggestion-mobile-top-panel form input').trigger('keydown');
       $('body.search .boost-pfs-search-suggestion-mobile-top-panel form input').trigger('input')
    })

    $('[data-search-close]').on('click',function(){
      $(this).closest('.control').find('input').val('');
      console.log($(this).closest('.control').find('input').val());
    })
  },
  unload: function unload($target) {
    Shopify.theme.breadcrumbs.unload();
  }
};